import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class UrlInterceptor implements HttpInterceptor {

  constructor() { }

  /**
 * Intercepts HTTP requests and modifies the request URL if necessary.
 * If the request URL doesn't already include the `ApiAppUrl` or points to an asset, 
 * it prepends the `ApiAppUrl` from the environment configuration.
 * 
 * @param request - The HTTP request to intercept.
 * @param next - The next handler to pass the request to.
 * @returns An observable of the HTTP response.
 */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    let clonnedRequest: HttpRequest<unknown> = request.clone();
    if (request.url.includes(environment.ApiAppUrl)) {
      return next.handle(clonnedRequest);
    }

    if (request.url.includes('assets')) {
      return next.handle(clonnedRequest);
    }
    clonnedRequest = request.clone({
      url: `${environment.ApiAppUrl}${request.url}`
    });

    return next.handle(clonnedRequest);
  }
}
